import { Injectable } from '@angular/core';
import { Effect, ofType, Actions } from '@ngrx/effects';
import { map, switchMap, catchError, tap } from 'rxjs/operators';
import { ApiService, WhoAmI$Response } from '@api/service';
// import * as UserAction from '../actions/user.action';
import * as appAction from './../actions';
import { Store } from '@ngrx/store';
import { of } from 'rxjs/internal/observable/of';

@Injectable()
export class UserEffects {
  @Effect()
  getUser$ = this.actions$.pipe(
    ofType(appAction.getUser),
    switchMap(() => {
      return this.api.user.whoAmI().pipe(
        tap((user: WhoAmI$Response) => {
          window['app'] = window['app'] || {};
          window['app'].features = user.features;
        }),
        map((user: WhoAmI$Response) => appAction.getUserSuccess(user)),
        catchError(err => of(appAction.getUserFail(err)))
      );
    })
  );

  @Effect()
  logout$ = this.actions$.pipe(
    ofType(appAction.logoutUser),
    switchMap(() => {
      return this.api.user.logout().pipe(
        tap(() => this.store.dispatch(new appAction.Go({ path: ['welcome'] }))),
        map(() => appAction.logoutUserSuccess()),
        catchError(err => of(appAction.logoutUserFail(err)))
      );
    })
  );

  @Effect()
  login$ = this.actions$.pipe(
    ofType(appAction.loginUser),
    switchMap(req => {
      return this.api.oauth.passwordAuth(req).pipe(
        tap(res => {
          if (res && res.role) {
            this.store.dispatch(new appAction.Go({ path: ['recipes'] }));
          } else {
            appAction.loginUserFail({ error: null });
          }
        }),
        map(res => appAction.loginUserSuccess(res)),
        catchError(err => of(appAction.loginUserFail(err)))
      );
    })
  );

  constructor(private actions$: Actions, private api: ApiService, private store: Store<any>) {}
}
